export const wealthPlanVisibleSelector = state => state.ui.wealthPlan.visible;
